import type {
  EnumLocaleAwareField,
  LocaleAwareFieldRule,
} from "@/app/services/extensions/localisationServiceExtended";
import type { Tenant } from "@/app/services/generated/tenantService";
import { localisationService } from "@/app/services/extensions/localisationServiceExtended";
import type BaseEnumType from "@/app/services/baseEnumType";

let rules: LocaleAwareFieldRule[] = [];

export async function loadForTenant(tenant: Tenant) {
  rules = await localisationService.getAllLocaleAwareFieldRules(tenant.id);
}

export interface LocaleAwareFieldRuleExtended extends LocaleAwareFieldRule {
  enumFilter: (a: BaseEnumType) => boolean;
}

export function getLocaleAwareRule(
  field: EnumLocaleAwareField
): LocaleAwareFieldRuleExtended {
  const foundRule = rules.find((r) => r.field === field);

  if (foundRule) {
    return Object.assign(
      {
        enumFilter: (a: BaseEnumType) =>
          !foundRule.enumValuesNotApplicable ||
          !foundRule.enumValuesNotApplicable.includes(a.key),
      },
      foundRule
    );
  } else {
    return {
      field,
      isApplicable: true,
      enumValuesNotApplicable: [],
      enumFilter: () => true,
    };
  }
}
